export default "__VITE_ASSET__MX2Fk5D4__"